import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {sx} from './sx'
import {MuiViewRenderProps} from "../types";
import moment from 'moment'
import Typography from '@mui/material/Typography';


const MuiSelectHours: FC<MuiViewRenderProps> = ({
                                                    value,
                                                    onChange,
                                                    onClose,
                                                    format,
                                                }) => {
    const {t} = useTranslation()

    const hours = Array.from({length: 24}, (_, i) => {
        return {
            hour: i,
            label: i > 9 ? i : `0${i}`
        }
    }).map(({hour, label}) => {
        const onClick = () => {
            onChange(moment(value).hour(hour).minutes(0))
            onClose()
        }
        const active = moment(value)?.hour() === hour;

        return (
            <Box
                sx={{
                    ...sx.item,
                    backgroundColor: active ? 'var(--account-accent, #0C6DDF)' : 'transparent',
                    color: active ? 'white' : undefined
                }}
                key={hour}
                onClick={onClick}
            >
                {label}:00
            </Box>
        )
    });

    return (
        <Stack
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            sx={sx.root}
        >
            <Typography
                sx={sx.title}
                variant={'body2'}
            >
                {t('base.time')}
            </Typography>

            {hours}
        </Stack>
    )
};

export default MuiSelectHours;